export const campaignStatuses = [
    {
        id: 1,
        name: "Paid",
    },
    {
        id: 2,
        name: "Trial",
    },
    {
        id: 3,
        name: "Deleted",
    },
    {
        id: 4,
        name: "Sandbox",
    },
    {
        id: 5,
        name: "Essentials",
    },
] as const;
